let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("O2IGv")).then(() => parcelRequire('9lbqx'));